import CreateActivity from './CreateActivity';

export default CreateActivity;
